<template>
  <section>
    <top-menu/>

    <section>
      <page-header :headerName="'Engajamento'" :showBtn="true" :btnName="'Voltar'"
                   :btnRoute="'/avisos-e-campanhas/liberacoes'" :css="'container'"/>

      <div class="page-content">
        <div class="container">
          <div class="row">

          <!--
            Com um banco fora do ar a lista abaixo esta INCOMPLETA: as empresas
            daquele banco simplesmente nao aparecem. Sem este aviso, uma empresa
            que nao recebeu a liberacao fica indistinguivel de uma empresa que a
            tela nao conseguiu ler.
          -->
          <div class="col-xs-12 fe-warn" v-if="shardsFailed.length">
            <p class="fe-warn__line">
              Números incompletos: {{ shardsFailed.join(', ') }} não responderam.
            </p>
            <ul class="fe-warn__why">
              <li v-for="failure in shardFailures" :key="failure.shardId">
                {{ failure.shardName || failure.shardId }}: {{ failure.error || 'motivo não informado' }}
              </li>
            </ul>
          </div>

          <p class="col-xs-12 fe-warn fe-warn--error" v-if="loadFailed">
            Não foi possível carregar esta liberação.
          </p>

          <template v-else-if="item">
            <div class="col-xs-12 default-box fe-head">
              <div class="fe-head__row">
                <!-- Uma liberacao pode ter dezenas de funcionalidades: o titulo
                     fica em uma linha e so abre inteiro a pedido. -->
                <h2 ref="title" class="fe-title" :class="{ 'is-expanded': expanded }">{{ item.featureName }}</h2>
                <button type="button" class="fe-more" v-if="overflows || expanded" @click="expanded = !expanded">
                  {{ expanded ? 'Ver menos' : 'Ver mais' }}
                </button>
              </div>
              <p class="fe-meta">
                {{ period }} ·
                <span class="fe-chip" :class="statusClass">{{ statusLabel }}</span>
                <template v-if="item.createdByName"> · criada por {{ item.createdByName }}</template>
                <template v-if="item.broadcastId">
                  ·
                  <router-link :to="'/avisos-e-campanhas/' + item.broadcastId + '/engajamento'">
                    Ver aviso
                  </router-link>
                </template>
              </p>
              <p class="fe-meta fe-meta--muted" v-if="item.notes">{{ item.notes }}</p>
            </div>

            <!-- ================================================ resumo -->
            <div class="col-xs-12 default-box">
              <h3 class="fe-section">Resumo</h3>

              <div class="fe-totals">
                <div class="fe-total">
                  <span class="fe-total__value">{{ item.targeted }}</span>
                  <span class="fe-total__label">empresas</span>
                </div>
                <div class="fe-total">
                  <span class="fe-total__value">{{ item.activated }}</span>
                  <span class="fe-total__label">ativações ligadas</span>
                </div>
                <div class="fe-total">
                  <span class="fe-total__value">{{ item.deactivated }}</span>
                  <span class="fe-total__label">ativações encerradas</span>
                </div>
                <div class="fe-total">
                  <span class="fe-total__value">{{ item.alreadyHad }}</span>
                  <span class="fe-total__label">já possuíam</span>
                </div>
                <div class="fe-total is-bad" v-if="item.failed">
                  <span class="fe-total__value">{{ item.failed }}</span>
                  <span class="fe-total__label">com falha</span>
                </div>
              </div>

              <p class="fe-note">
                Ativações contam empresa × funcionalidade. Empresas marcadas como
                "já possuía" não foram alteradas e não serão desligadas no fim da
                liberação.
              </p>
            </div>

            <!-- ============================================== empresas -->
            <div class="col-xs-12 default-box">
              <h3 class="fe-section">Empresas</h3>

              <!-- A barra aparece SEMPRE, como no engajamento das campanhas:
                   sem linhas a exportacao fica desabilitada, que e a resposta
                   honesta. -->
              <div class="fe-toolbar">
                <input type="text" class="form-control fe-search" v-model="term"
                       placeholder="Filtrar por empresa, id ou funcionalidade">
                <button type="button" class="btn default fe-export" :disabled="!visibleRows.length"
                        @click="exportRows">
                  Exportar
                </button>
              </div>

              <!-- Busca e ordenacao valem para a lista inteira; so entao a
                   tabela corta a pagina. A exportacao leva tudo que a busca
                   deixou, nao so a pagina visivel. -->
              <paged-table class="fe-table" v-if="visibleRows.length" :rows="visibleRows"
                           storage-key="feature-window-engagement-companies" v-slot="{ rows: pageRows }">
                  <thead>
                  <tr>
                    <th v-for="column in columns" :key="column.key" class="fe-sortable"
                        :style="column.width ? { width: column.width } : null"
                        :aria-sort="ariaSort(column.key)"
                        @click="sortBy(column.key)">
                      {{ column.label }}<span class="fe-caret" v-if="sortKey === column.key">{{ caret }}</span>
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="row in pageRows" :key="row.contextCode + ':' + row.companyId + ':' + row.featureType">
                    <td>
                      {{ row.name || row.companyId }}
                      <!-- O motivo da falha aparece inteiro: e a unica pista do
                           que impediu a empresa de receber a liberacao. -->
                      <small class="fe-reason" v-if="row.failureReason">{{ row.failureReason }}</small>
                    </td>
                    <td>{{ row.featureName }}</td>
                    <td>{{ row.contextCode }}</td>
                    <td>{{ dateTime(row.activatedAt) }}</td>
                    <td>{{ dateTime(row.deactivatedAt) }}</td>
                    <td>
                      <span class="fe-chip" :class="situationClass(row)">{{ situationLabel(row) }}</span>
                    </td>
                  </tr>
                  </tbody>
              </paged-table>

              <p class="fe-empty" v-else-if="rows.length">
                Nenhuma linha corresponde a "{{ term }}".
              </p>

              <p class="fe-empty" v-else>
                Nenhuma empresa nesta liberação.
              </p>
            </div>
          </template>

          </div>
        </div>
      </div>
    </section>

    <full-loading v-if="loading"/>
  </section>
</template>

<script>
/**
 * Engajamento de UMA liberacao, em pagina propria — o mesmo lugar que o
 * engajamento de uma campanha ocupa. Substitui o painel lateral: um link pode
 * ser copiado, favoritado e aberto em outra aba; um painel nao.
 */
import topMenu from "../../components/default/topMenu.vue";
import pageHeader from "../../components/default/pageHeader.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import pagedTable from "../../components/default/pagedTable.vue";
import { requestApiV2 } from "../broadcast/broadcastApiV2Auth";
import { csvDateTime, csvFileName, downloadCsv } from "../broadcast/broadcastExport";
import { FEATURE_WINDOW_BY_ID } from "../../../../urlConfig";

const TEXT_COLUMNS = ['name', 'featureName', 'contextCode', 'situation'];

export default {
  name: "feature-window-engagement-page",
  components: { topMenu, pageHeader, fullLoading, pagedTable },
  data() {
    return {
      loading: false,
      loadFailed: false,
      data: {},
      term: '',
      sortKey: 'name',
      sortDir: 1,
      expanded: false,
      overflows: false,
      columns: [
        { key: 'name', label: 'Empresa' },
        { key: 'featureName', label: 'Funcionalidade', width: '200px' },
        { key: 'contextCode', label: 'Banco', width: '110px' },
        { key: 'activatedAt', label: 'Ligada em', width: '160px' },
        { key: 'deactivatedAt', label: 'Encerrada em', width: '160px' },
        { key: 'situation', label: 'Situação', width: '130px' },
      ],
    };
  },
  computed: {
    windowId() {
      return this.$route.params.id;
    },
    item() {
      return this.data.window || null;
    },
    rows() {
      return this.data.companies || [];
    },
    shardsFailed() {
      return this.data.shardsFailed || [];
    },
    shardFailures() {
      return this.data.shardFailures || [];
    },
    visibleRows() {
      const term = (this.term || '').trim().toLowerCase();

      const filtered = term
        ? this.rows.filter((row) =>
            [row.name, row.companyId, row.contextCode, row.featureName]
              .join(' ')
              .toLowerCase()
              .indexOf(term) >= 0)
        : this.rows.slice();

      const key = this.sortKey;
      const dir = this.sortDir;
      const valueOf = (row) => (key === 'name' ? row.name || row.companyId : row[key]);

      return filtered.sort((a, b) => {
        const left = valueOf(a);
        const right = valueOf(b);

        if (left === right) return 0;
        // Vazio sempre no fim, em qualquer direcao: sem "Ligada em" nao e a
        // mais antiga, e ausencia de ativacao.
        if (left === null || left === undefined || left === '') return 1;
        if (right === null || right === undefined || right === '') return -1;

        return String(left).localeCompare(String(right), 'pt-BR') * dir;
      });
    },
    caret() {
      return this.sortDir === 1 ? ' ↑' : ' ↓';
    },
    period() {
      return this.date(this.item.startsAt) + ' até ' + this.date(this.item.endsAt);
    },
    /** Mesmas palavras da lista (featureWindowList.vue). */
    statusLabel() {
      const status = this.item.status;
      if (status === 'Cancelled') return 'Cancelada';
      if (status === 'Scheduled') return 'Agendada';
      if (status === 'Active') return 'Ativa';
      return 'Finalizada';
    },
    statusClass() {
      const status = this.item.status;
      if (status === 'Active') return 'is-live';
      if (status === 'Cancelled') return 'is-cancelled';
      return 'is-muted';
    },
  },
  watch: {
    // "Ver mais" so existe se o titulo realmente nao coube em uma linha.
    item() {
      this.expanded = false;
      this.$nextTick(this.measureTitle);
    },
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      this.loading = true;
      this.loadFailed = false;

      requestApiV2('GET', FEATURE_WINDOW_BY_ID(this.windowId))
        .then((response) => {
          this.data = (response && response.data) || {};
        })
        .catch(() => {
          // Falha de leitura nao pode virar "nenhuma empresa": as duas telas sao
          // iguais e dizem coisas opostas.
          this.data = {};
          this.loadFailed = true;
        })
        .then(() => {
          this.loading = false;
        });
    },
    measureTitle() {
      const el = this.$refs.title;
      this.overflows = !!el && el.scrollWidth > el.clientWidth;
    },
    sortBy(key) {
      if (this.sortKey === key) {
        this.sortDir = this.sortDir * -1;
        return;
      }
      this.sortKey = key;
      // Texto comeca do A; data comeca da mais recente.
      this.sortDir = TEXT_COLUMNS.indexOf(key) !== -1 ? 1 : -1;
    },
    ariaSort(key) {
      if (this.sortKey !== key) return 'none';
      return this.sortDir === 1 ? 'ascending' : 'descending';
    },
    /** Os literais vem do servidor (FeatureWindowCompanySituation). */
    situationLabel(row) {
      if (row.situation === 'AlreadyHad') return 'Já possuía';
      if (row.situation === 'Active') return 'Ligada';
      if (row.situation === 'Deactivated') return 'Encerrada';
      if (row.situation === 'Failed') return 'Falhou';
      return 'Aguardando';
    },
    situationClass(row) {
      if (row.situation === 'Active') return 'is-live';
      if (row.situation === 'Failed') return 'is-cancelled';
      return 'is-muted';
    },
    date(value) {
      if (!value) return '';
      const parsed = new Date(value);
      return isNaN(parsed.getTime()) ? '' : parsed.toLocaleDateString('pt-BR');
    },
    dateTime(value) {
      if (!value) return '';
      const parsed = new Date(value);
      return isNaN(parsed.getTime()) ? '' : parsed.toLocaleString('pt-BR');
    },
    /** Exporta tudo que a busca deixou, na ordem da tela — nao so a pagina visivel. */
    exportRows() {
      const incomplete = this.shardsFailed.length > 0;

      const head = ['Empresa', 'Id da empresa', 'Banco', 'Funcionalidade', 'Ligada em',
                    'Encerrada em', 'Situação', 'Motivo da falha'];

      const rows = this.visibleRows.map((row) => [
        row.name || '', row.companyId, row.contextCode, row.featureName || '',
        csvDateTime(row.activatedAt), csvDateTime(row.deactivatedAt),
        this.situationLabel(row), row.failureReason || '',
      ]);

      downloadCsv(head, rows, csvFileName('liberacao ' + this.item.featureName, incomplete));
    },
  },
};
</script>

<style scoped>
/* Mesmo desenho de broadcastEngagementPage.vue. */
.default-box { margin-bottom: 20px; padding-bottom: 18px; }

.fe-head { padding-top: 16px; }
.fe-head__row { display: flex; align-items: flex-start; gap: 12px; }
.fe-title { flex: 1 1 auto; min-width: 0; margin: 0; font-size: 20px; font-weight: 700; color: #3a424e; }
.fe-title:not(.is-expanded) { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.fe-more {
  flex: 0 0 auto;
  border: 0;
  background: none;
  padding: 0;
  margin-top: 6px;
  font-size: 12px;
  color: #2F23D6;
  cursor: pointer;
  white-space: nowrap;
}
.fe-more:hover { text-decoration: underline; }
.fe-meta { margin: 6px 0 0; font-size: 13px; color: #4e5560; }
.fe-meta--muted { color: #9ca0a7; }

.fe-section {
  width: 100%;
  margin: 18px 0 12px;
  padding-bottom: 6px;
  border-bottom: 1px solid #eceff3;
  font-size: 16px;
  font-weight: 700;
  color: #3a424e;
}

.fe-chip {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
}
.fe-chip.is-live { background: #ecf9ef; color: #12b937; }
.fe-chip.is-cancelled { background: #fff0f2; color: #ff445d; }
.fe-chip.is-muted { background: #f4f4f5; color: #4e5560; }

.fe-warn {
  background: #fff9eb;
  color: #ffb800;
  border-radius: 6px;
  padding: 10px 14px;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 16px;
}
.fe-warn--error { background: #fff0f2; color: #ff445d; }
.fe-warn__line { margin: 0; }
.fe-warn__why { margin: 6px 0 0; padding-left: 18px; font-weight: 400; font-size: 11px; }

.fe-totals { display: flex; flex-wrap: wrap; gap: 32px; }
.fe-total { display: flex; flex-direction: column; }
.fe-total__value { font-size: 22px; font-weight: 700; color: #3a424e; line-height: 1.1; }
.fe-total__label { font-size: 12px; color: #9ca0a7; }
.fe-total.is-bad .fe-total__value { color: #ff445d; }

.fe-note { margin: 14px 0 0; font-size: 11px; color: #9ca0a7; max-width: 640px; }
.fe-empty { margin: 8px 0 0; font-size: 13px; color: #4e5560; }

.fe-table th { font-size: 12px; font-weight: 600; color: #4e5560; border-bottom: 1px solid #d5d7da; }
.fe-sortable { cursor: pointer; user-select: none; white-space: nowrap; }
.fe-sortable:hover { color: #1b59f8; }
.fe-caret { color: #1b59f8; }
.fe-reason { display: block; font-size: 11px; color: #ff445d; margin-top: 2px; }

.fe-toolbar { display: flex; align-items: center; gap: 12px; margin-bottom: 10px; }
.fe-search { max-width: 320px; font-size: 13px; }
.fe-export { margin-left: auto; }

</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/featureWindow/featureWindowEngagementPage.vue